import { Component, EventEmitter, Input, Output } from '@angular/core';
import { InputGeneral } from '../../../shared/inputs/input-general/input-general';
import { InputGeneralSelectComponent } from '../../../shared/inputs/input-general-select/input-general-select.component';
import { InputGeneralCalendarComponent } from '../../../shared/inputs/input-general-calendar/input-general-calendar.component';
import { NgClass } from '@angular/common';
import { HybridModel } from '../../../shared/models/hybrid-model/hybrid-model';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { GeneralService } from '../../../shared/services/general.service';
import { Subscription } from 'rxjs';
import { provideNativeDateAdapter } from '@angular/material/core';
import { MatCheckbox } from '@angular/material/checkbox';
import { InputGeneralTextComponent } from '../../../shared/inputs/input-general-text/input-general-text.component';

@Component({
  selector: 'app-hybrid-page',
  imports: [
    InputGeneralSelectComponent,
    InputGeneralCalendarComponent,
    ReactiveFormsModule,
    InputGeneral,
    MatCheckbox,
    NgClass,
    InputGeneralTextComponent,
  ],
  providers: [provideNativeDateAdapter()],
  templateUrl: './hybrid-page.html',
  styleUrl: './hybrid-page.css',
})
export class HybridPage {
  @Input() public formGeneral: FormGroup = new FormGroup({});
  @Input() public formHydrid: HybridModel[] = [];
  @Input() public colummMax = 2;
  @Output() public formGeneralChange = new EventEmitter<FormGroup>();
  private subscription: Subscription | null = null;
  constructor(private generalService: GeneralService) {}

  ngOnInit() {
    this.createFormGroup();
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  public disableControl(key: string): void {
    const control = this.formHydrid.find((input) => input.key === key)?.control;
    control?.disable();
  }

  private createFormGroup(): void {
    this.formHydrid.forEach((input) => {
      if (input.control && input.disabled) {
        input.control.disable();
      }

      if (!this.formGeneral.contains(input.key)) {
        this.formGeneral.addControl(input.key, input.control);
      }
    });

    const sub = this.generalService.subscribeForm(this.formGeneral).subscribe((value) => {
      this.formGeneralChange.emit(this.formGeneral);
    });
    this.subscription = sub;
  }
}
